import { Injectable } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AdministratorFacade, SharedFacade, getRolesAndPermission } from '@piqet-angular/data';
import {
  ADMIN_EOL_CONSUMER,
  dblclickTooltipDef,
  defaultColumn,
  DELETE_RECORD_LABEL,
  grid_widths_map,
  rolesModuleName,
  subModuleName,
} from '@piqet-angular/shared';
import { right } from '@popperjs/core';
import { ColDef } from 'ag-grid-community';
import { AdministratorService } from 'libs/data/src/lib/services/administrator/administrator.service';
import { SwalService } from 'libs/shared/src/lib/service/swal.service';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class EolDataGridService {
  event: any;
  eolPayload: any;
  endPoint: any;
  endPointEOL: any;
  editDatas = new Subject<[any, any, any, any, any]>();
  EolObservable$ = this.editDatas.asObservable();
  deleteData = new Subject<[any, any, any]>();
  EolDeleteObservable$ = this.deleteData.asObservable();
  reviewNameEOL: any;

  constructor(
    private swalService: SwalService,
    public administratorFacade: AdministratorFacade,
    private router: Router,
    public route: ActivatedRoute,
    private administratorService: AdministratorService,
    private sharedFacade: SharedFacade
  ) {}

  getAdminEolColumns(activatedRoute?: any): ColDef[] {
    const i = activatedRoute?.indexOf('-');
    const editName = activatedRoute?.slice(i + 1)?.toUpperCase();
    const splitStrings = editName.split('-');
    const firstPart = splitStrings[0].toUpperCase();
    const secondPart = splitStrings[1].toLowerCase();

    const result = firstPart + ' ' + secondPart;
    const colDef: ColDef[] = [];

    colDef.push({
      ...defaultColumn,
      colId: 'OrderId',
      headerName: 'OrderId',
      field: 'OrderId',
      hide: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'MaterialCategoryName',
      headerName: 'Material category',
      field: 'materialCategoryName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      resizable: false,
      filter: 'agTextColumnFilter',
      lockVisible: true,
      wrapHeaderText: true,
      cellRenderer: (params: any) => {
        const cellValue = params.value;
        const cellElement = document.createElement('span');
        cellElement.innerHTML = `${cellValue}`;
        cellElement.style.textDecoration = 'underline';
        const showEdit = this.isAccess(editName) ? this.isAccess(editName).isEdit : true;
        if (showEdit) {
          cellElement.style.cursor = 'pointer';
        }
        this.getAdminpathAndReviewname(activatedRoute);
        cellElement.title = dblclickTooltipDef;
        cellElement.addEventListener('dblclick', () => {
          const showEdit = this.isAccess(editName) ? this.isAccess(editName).isEdit : true;
          showEdit &&
            this.editDatas.next([
              params.data.materialId,
              params.data.regionId,
              'Review EOL detail',
              this.endPointEOL,
              this.reviewNameEOL,
            ]);
        });
        return cellElement;
      },
    });

    colDef.push({
      ...defaultColumn,
      colId: 'MaterialCode',
      headerName: 'Material code',
      field: 'materialCode',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      resizable: false,
      filter: 'agTextColumnFilter',
      lockVisible: true,
      wrapHeaderText: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'MaterialName',
      headerName: 'Material',
      field: 'materialName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      resizable: false,
      filter: 'agTextColumnFilter',
      lockVisible: true,
      cellRenderer: (params: any) => {
        return `<div class="truncated-text" title="${params.value}">${
          params.value ? params.value : ''
        }</div>`;
      },
      wrapHeaderText: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'RegionCode',
      headerName: 'Region code',
      field: 'regionCode',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      resizable: false,
      filter: 'agTextColumnFilter',
      lockVisible: true,
      wrapHeaderText: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'RegionName',
      headerName: 'Region',
      field: 'regionName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      resizable: false,
      filter: 'agTextColumnFilter',
      lockVisible: true,
      wrapHeaderText: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'OrganizationName',
      headerName: 'Organization',
      field: 'organizationName',
      cellClass: 'my-permission-cursor-pointer',
      wrapText: true,
      autoHeight: true,
      resizable: false,
      filter: 'agTextColumnFilter',
      lockVisible: true,
      wrapHeaderText: true,
    });

    colDef.push({
      ...defaultColumn,
      colId: 'Actions',
      headerName: 'Actions',
      field: 'actions',
      sortable: false,
      maxWidth: grid_widths_map.sm_column_xs,
      cellRendererParams: {
        showEdit: this.isAccess(editName) ? this.isAccess(editName).isEdit : true,
        showDelete: this.isAccess(editName) ? this.isAccess(editName).isDelete : true,
        value: 'admin-recycled',
        editData: (data: any, pathName: any, endPoint: any, reviewName: any) => {
          this.editDatas.next([
            data.materialId,
            data.regionId,
            'Review EOL detail',
            endPoint,
            reviewName,
          ]);
        },
        deleteData: (data: any) => {
          switch (editName) {
            case 'EOL-RC':
              this.endPoint = '/EOL_RC/DeleteEndofLifeRC';
              break;
            case 'EOL-LF':
              this.endPoint = '/EOL_LF/DeleteEndofLifeLF';
              break;
            case 'EOL-CC':
              this.endPoint = '/EOL_CC/DeleteEndofLifeCC';
              break;
            case 'EOL-HC':
              this.endPoint = '/EOL_HC/DeleteEndofLifeHC';
              break;
            case 'EOL-ER':
              this.endPoint = '/EOL_ER/DeleteEndofLifeER';
              break;
            case 'EOL-IC':
              this.endPoint = '/EOL_IC/DeleteEndofLifeIC';
              break;
            case 'EOL-OD':
              this.endPoint = '/EOL_OD/DeleteEndofLifeOD';
              break;
            case 'EOL-SW':
              this.endPoint = '/EOL_SW/DeleteEndofLifeSW';
              break;
            case 'EOL-SE':
              this.endPoint = '/EOL_SE/DeleteEndofLifeSE';
              break;
            case 'EOL-LT':
              this.endPoint = '/EOL_LT/DeleteEndofLifeLT';
              break;
            case 'EOL-AD':
              this.endPoint = '/EOL_AD/DeleteEndofLifeAD';
              break;
            case 'EOL-RATES':
              this.endPoint = '/EOLRates/DeleteEOLImpactRates';
              break;
            case 'EOL-CONSUMERS':
              this.endPoint = '/EOLConsumerRates/DeleteEOLImpactConsumerRates';
              break;
            case 'EOL-OR':
              this.endPoint = '/EOL_OR/DeleteEndofLifeOR';
              break;
            case 'EOL-CR':
              this.endPoint = '/EOL_CR/DeleteEndofLifeCR';
              break;
            case 'EOL-PG':
              this.endPoint = '/EOL_PG/DeleteEndofLifePG';
              break;
            case 'EOL-OB':
              this.endPoint = '/EOL_OB/DeleteEndofLifeOB';
              break;
            case 'EOL-NO':
              this.endPoint = '/EOL_NO/DeleteEndofLifeNO';
              break;
          }
          this.deleteProjectWorkflowConfirmation(data.materialId, data.regionId, this.endPoint);
        },
      },
      cellClass: 'my-permission-cursor-pointer',
      cellRenderer: 'actionRenderer',
      lockVisible: true,
      lockPosition: right,
      resizable: false,
    });
    return colDef;
  }

  isAccess = (pathName: any) => {
    switch (pathName) {
      case 'EOL-RC':
      case 'admin-eol-rc':
        return getRolesAndPermission(rolesModuleName.DataManageEOLRC, subModuleName.EOLDataModule);
        break;
      case 'EOL-LF':
      case 'admin-eol-lf':
        return getRolesAndPermission(rolesModuleName.DataManageEOLLF, subModuleName.EOLDataModule);
        break;
      case 'EOL-CC':
      case 'admin-eol-cc':
        return getRolesAndPermission(rolesModuleName.DataManageEOLCC, subModuleName.EOLDataModule);
        break;
      case 'EOL-HC':
      case 'admin-eol-hc':
        return getRolesAndPermission(rolesModuleName.DataManageEOLHC, subModuleName.EOLDataModule);
        break;
      case 'EOL-ER':
      case 'admin-eol-er':
        return getRolesAndPermission(rolesModuleName.DataManageEOLER, subModuleName.EOLDataModule);
        break;
      case 'EOL-IC':
      case 'admin-eol-ic':
        return getRolesAndPermission(rolesModuleName.DataManageEOLIC, subModuleName.EOLDataModule);
        break;
      case 'EOL-OD':
      case 'admin-eol-od':
        return getRolesAndPermission(rolesModuleName.DataManageEOLOD, subModuleName.EOLDataModule);
        break;
      case 'EOL-SW':
      case 'admin-eol-sw':
        return getRolesAndPermission(rolesModuleName.DataManageEOLSW, subModuleName.EOLDataModule);
        break;
      case 'EOL-SE':
      case 'admin-eol-se':
        return getRolesAndPermission(rolesModuleName.DataManageEOLSE, subModuleName.EOLDataModule);
        break;
      case 'EOL-LT':
      case 'admin-eol-lt':
        return getRolesAndPermission(rolesModuleName.DataManageEOLLT, subModuleName.EOLDataModule);
        break;
      case 'EOL-AD':
      case 'admin-eol-ad':
        return getRolesAndPermission(rolesModuleName.DataManageEOLAD, subModuleName.EOLDataModule);
        break;
      case 'EOL-RATES':
      case 'admin-eol-rates':
        return getRolesAndPermission(
          rolesModuleName.DataManageEOLrates,
          subModuleName.EOLDataModule
        );
        break;
      case 'EOL-CONSUMERS':
      case ADMIN_EOL_CONSUMER:
        return getRolesAndPermission(
          rolesModuleName.DataManageEOLconsumers,
          subModuleName.EOLDataModule
        );
        break;
      case 'EOL-NO':
      case 'admin-eol-no':
        return getRolesAndPermission(rolesModuleName.DataManageEOLNO, subModuleName.EOLDataModule);
        break;
      case 'EOL-OR':
      case 'admin-eol-or':
        return getRolesAndPermission(rolesModuleName.DataManageEOLOR, subModuleName.EOLDataModule);
        break;
      case 'EOL-CR':
      case 'admin-eol-cr':
        return getRolesAndPermission(rolesModuleName.DataManageEOLCR, subModuleName.EOLDataModule);
        break;
      case 'EOL-PG':
      case 'admin-eol-pg':
        return getRolesAndPermission(rolesModuleName.DataManageEOLPG, subModuleName.EOLDataModule);
        break;
      case 'EOL-OB':
      case 'admin-eol-ob':
        return getRolesAndPermission(rolesModuleName.DataManageEOLOB, subModuleName.EOLDataModule);
        break;
    }
  };

  deleteProjectWorkflowConfirmation(materialId: any, regionId: any, endPoint: any) {
    this.swalService.confirm('Are you sure?', DELETE_RECORD_LABEL).then(confirmed => {
      if (confirmed) {
        this.deleteData.next([materialId, regionId, endPoint]);
      } else {
      }
    });
  }

  getAdminpathAndReviewname(activatedRouteRole: string) {
    switch (activatedRouteRole) {
      case 'admin-eol-rc':
        this.reviewNameEOL = 'Review EOL recycling detail';
        this.endPointEOL = '/EOL_RC/GetEndofLifeRCForAddUpdate';
        break;
      case 'admin-eol-lf':
        this.reviewNameEOL = 'Review EOL landfill detail';
        this.endPointEOL = '/EOL_LF/GetEndofLifeLFForAddUpdate';
        break;
      case 'admin-eol-cc':
        this.reviewNameEOL = 'Review EOL commercial composting detail';
        this.endPointEOL = '/EOL_CC/GetEndofLifeCCForAddUpdate';
        break;
      case 'admin-eol-hc':
        this.reviewNameEOL = 'Review EOL home composting detail';
        this.endPointEOL = '/EOL_HC/GetEndofLifeHCForAddUpdate';
        break;
      case 'admin-eol-er':
        this.reviewNameEOL = 'Review EOL waste energy recovery detail';
        this.endPointEOL = '/EOL_ER/GetEndofLifeERForAddUpdate';
        break;
      case 'admin-eol-ic':
        this.reviewNameEOL = 'Review EOL incineration detail';
        this.endPointEOL = '/EOL_IC/GetEndofLifeICForAddUpdate';
        break;
      case 'admin-eol-od':
        this.reviewNameEOL = 'Review open dump detail';
        this.endPointEOL = '/EOL_OD/GetEndofLifeODForAddUpdate';
        break;
      case 'admin-eol-sw':
        this.reviewNameEOL = 'Review EOL storm water detail';
        this.endPointEOL = '/EOL_SW/GetEndofLifeSWForAddUpdate';
        break;
      case 'admin-eol-se':
        this.reviewNameEOL = 'Review EOL sewer detail';
        this.endPointEOL = '/EOL_SE/GetEndofLifeSEForAddUpdate';
        break;
      case 'admin-eol-lt':
        this.reviewNameEOL = 'Review EOL litter detail';
        this.endPointEOL = '/EOL_LT/GetEndofLifeLTForAddUpdate';
        break;
      case 'admin-eol-ad':
        this.reviewNameEOL = 'Review EOL anerobicdigestion detail';
        this.endPointEOL = '/EOL_AD/GetEndofLifeADForAddUpdate';
        break;
      case 'admin-eol-rates':
        this.reviewNameEOL = 'Review EOL rates detail';
        this.endPointEOL = '/EOLRates/GetEndofLifeADForAddUpdate';
        break;
      case ADMIN_EOL_CONSUMER:
        this.reviewNameEOL = 'Review EOL consumer detail';
        this.endPointEOL = '/EOLConsumerRates/GetEndofLifeConsumerADForAddUpdate';
        break;
      case 'admin-eol-or':
        this.reviewNameEOL = 'Review EOL recycling open loop detail';
        this.endPointEOL = '/EOL_OR/GetEndofLifeORForAddUpdate';
        break;
      case 'admin-eol-cr':
        this.reviewNameEOL = 'Review EOL chemical recycling detail';
        this.endPointEOL = '/EOL_CR/GetEndofLifeCRForAddUpdate';
        break;
      case 'admin-eol-pg':
        this.reviewNameEOL = 'Review EOL pyrolysis/gasification detail';
        this.endPointEOL = '/EOL_PG/GetEndofLifePGForAddUpdate';
        break;
      case 'admin-eol-ob':
        this.reviewNameEOL = 'Review EOL open burning detail';
        this.endPointEOL = '/EOL_OB/GetEndofLifeOBForAddUpdate';
        break;
      case 'admin-eol-no':
        this.reviewNameEOL = 'Review EOL none detail';
        this.endPointEOL = '/EOL_NO/GetEndofLifeNOForAddUpdate';
        break;
    }
  }

  getEolPayload(searchData: any, sortColumnState?: any, event?: any) {
    if (event) {
      this.event = event;
    }
    const currentPage = this.event?.goToPage
      ? this.event.goToPage
      : this.event?.next
      ? this.event.currentPage + 1
      : this.event?.prev
      ? this.event?.currentPage - 1
      : this.event?.gridApi?.paginationGetCurrentPage() + 1;
    const pageSize = this.event?.gridApi.paginationGetPageSize();
    const startCount = pageSize * (currentPage - 1);

    const columns = this.getAdminEolColumns()
      .map((item: any) => {
        return {
          searchable: true,
          name: item.colId,
          orderable: true,
          data: item.colId,
        };
      })
      .filter(value => value?.name != 'Actions');

    return (this.eolPayload = {
      search: {
        columnNameList: [],
        value: searchData || '',
      },
      columns: columns,
      order: [
        {
          columnName: sortColumnState?.columnName || 'OrderId',
          dir:
            sortColumnState?.dir[0].toUpperCase() + sortColumnState?.dir.substr(1).toLowerCase() ||
            'Asc',
        },
      ],
      start: startCount || 0,
      length: pageSize == Number(this.event?.totalRecord) ? Number('-1') : pageSize || 10,
      draw: currentPage || 1,
    });
  }
}
